import { all } from 'redux-saga/effects';
import insightSaga from 'store/insights/insightsSaga';

export default function* () {
	yield all([insightSaga()]);
}
